import './Frontend.css';
import VerticalStepper from '../UI/VerticalStepper';
import { useEffect, useState } from 'react';
import HomeNavbar from '../UI/HomeNavbar';
import LoadingModal from '../UI/LoadingModal';
import { useUserAuth } from '../../context/UserAuthContext';
import ErrorModal from '../UI/ErrorModal';

const Backend = ({saveProgressData, getProgressData}) => {
    const SetupSteps = [
        {
            label: 'Node.js Installation',
            description: `Learn how to install Node.js on your computer. Node.js is a JavaScript runtime that enables you to execute code outside of a web browser.`,
            link: 'https://www.w3schools.com/nodejs/nodejs_get_started.asp'
        },
        {
            label: 'MongoDB Installation',
            description: `Set up MongoDB on your system. MongoDB is a NoSQL database used to store and retrieve data for your backend applications.`,
            link: 'https://medium.com/@LondonAppBrewery/how-to-download-install-mongodb-on-windows-4ee4b3493514'
        }
    ];

    const NodeSteps = [
        {
            label: 'Node.js Basics',
            description: `Learn the basics of Node.js, including its role as a server-side JavaScript runtime.`,
            link: 'https://www.w3schools.com/nodejs/nodejs_intro.asp'
        },
        {
            label: 'Express Basics',
            description: `Understand the fundamentals of Express.js, a web application framework for Node.js, used to build APIs and web apps.`,
            link: 'https://www.youtube.com/watch?v=L72fhGm1tfE'
        },
        {
            label: 'Routing in Express',
            description: `Learn to define routes and handle HTTP requests using Express.js, allowing you to control your application's behavior.`,
            link: 'https://www.youtube.com/watch?v=Zh7psmf1KAA'
        }
    ]

    const APISteps = [
        {
            label: 'Introduction to REST',
            description: `Understand the principles of REST (Representational State Transfer), a set of architectural constraints for designing APIs.`,
            link: 'https://www.guru99.com/restful-web-services.html'
        },
        {
            label: 'Creating Endpoints',
            description: `Learn to create API endpoints for various operations, enabling your application to respond to client requests.`,
            link: 'https://stackabuse.com/building-a-rest-api-with-node-and-express/'
        }
    ];

    const MongoSteps = [
        {
            label: 'MongoDB Basics',
            description: `Explore MongoDB's data storage and retrieval capabilities, allowing you to manage and manipulate data within your application.`,
            link: 'https://www.youtube.com/watch?v=9OPP_1eAENg'
        },
        {
            label: 'Working with Mongoose',
            description: `Understand how Mongoose simplifies database interactions, providing a structured way to interact with MongoDB.`,
            link: 'https://www.youtube.com/watch?v=qj2oDkvc4dQ'
        }
    ]

    const AuthSteps = [
        {
            label: 'User Authentication',
            description: `Implement user authentication in your application, ensuring secure access and user-specific interactions.`,
            link: 'https://www.youtube.com/watch?v=6FOq4cUdH8k'
        },
        {
            label: 'Security Best Practices',
            description: `Learn about security measures to protect your application from common vulnerabilities and threats.`,
            link: 'https://www.youtube.com/watch?v=1UYBAn69Qrk'
        }
    ]

    const ErrorSteps = [
        {
            label: 'Error Handling in Express',
            description: `Implement error handling mechanisms in Express to gracefully handle errors and prevent application crashes.`,
            link: 'https://www.geeksforgeeks.org/error-handling-in-express/'
        },
        {
            label: 'Middleware in Express',
            description: `Understand the role of middleware in Express applications and learn to use it effectively for various tasks.`,
            link: 'https://www.geeksforgeeks.org/middleware-in-express-js/'
        }
    ];

    const DeploymentSteps = [
        {
            label: 'Preparing for Deployment',
            description: `Prepare your application for deployment by optimizing, configuring, and testing it for production environments.`,
            link: 'https://medium.com/geekculture/build-and-deploy-a-web-application-with-react-and-node-js-express-bce2c3cfec32'
        },
        {
            label: 'Hosting on Render',
            description: `Deploy your application on the Render platform, a cloud provider designed for simplicity and ease of use.`,
            link: 'https://www.freecodecamp.org/news/how-to-deploy-nodejs-application-with-render/'
        }
    ]

    // Totol Steps = 15

    // The total Progress is for progress graph for every user whereas individual step progress is for saving the progress in DB
    const [totalCompletedSteps, setTotalCompletedSteps] = useState(0);

    // Setup Progress
    const [setupCompletedSteps, setSetupCompletedSteps] = useState(0);

    const handleSetupStepComplete = () => {
        setSetupCompletedSteps(setupCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
        console.log(setupCompletedSteps);
    };

    const handleSetupStepBack = () => {
        setSetupCompletedSteps(setupCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Node Progress
    const [nodeCompletedSteps, setNodeCompletedSteps] = useState(0);

    const handleNodeStepComplete = () => {
        setNodeCompletedSteps(nodeCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleNodeStepBack = () => {
        setNodeCompletedSteps(nodeCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //API Integration Progress
    const [apiCompletedSteps, setApiCompletedSteps] = useState(0);

    const handleApiStepComplete = () => {
        setApiCompletedSteps(apiCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleApiStepBack = () => {
        setApiCompletedSteps(apiCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //MongoDB Progress
    const [mongoCompletedSteps, setMongoCompletedSteps] = useState(0);

    const handleMongoStepComplete = () => {
        setMongoCompletedSteps(mongoCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleMongoStepBack = () => {
        setMongoCompletedSteps(mongoCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Authentication Progress
    const [authCompletedSteps, setAuthCompletedSteps] = useState(0);

    const handleAuthStepComplete = () => {
        setAuthCompletedSteps(authCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleAuthStepBack = () => {
        setAuthCompletedSteps(authCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };
    
    //Error Handling Progress
    const [errorCompletedSteps, setErrorCompletedSteps] = useState(0);

    const handleErrorStepComplete = () => {
        setErrorCompletedSteps(errorCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleErrorStepBack = () => {
        setErrorCompletedSteps(errorCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Deployment Progress
    const [deployCompletedSteps, setDeployCompletedSteps] = useState(0);

    const handleDeployStepComplete = () => {
        setDeployCompletedSteps(deployCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleDeployStepBack = () => {
        setDeployCompletedSteps(deployCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

     //Firestore data
     useEffect(() =>{
        saveProgressData({
            totalSteps: 15,
            totalCompletedSteps: totalCompletedSteps,
            setupCompletedSteps: setupCompletedSteps,
            nodeCompletedSteps: nodeCompletedSteps,
            mongoCompletedSteps: mongoCompletedSteps,
            apiCompletedSteps: apiCompletedSteps,
            authCompletedSteps: authCompletedSteps,
            errorCompletedSteps: errorCompletedSteps,
            deployCompletedSteps: deployCompletedSteps
        });
    }, [totalCompletedSteps, setupCompletedSteps, nodeCompletedSteps, mongoCompletedSteps, apiCompletedSteps, authCompletedSteps, errorCompletedSteps, deployCompletedSteps]);

    const {currentUser, isLoading} = useUserAuth();
    const [error, setError] = useState('');

    useEffect(() => {
        const asyncFunc = async() => {
            const progressData = await getProgressData();
            console.log(progressData);
            if (progressData) {
                setTotalCompletedSteps(progressData.totalCompletedSteps);
                setSetupCompletedSteps(progressData.setupCompletedSteps);
                setNodeCompletedSteps(progressData.nodeCompletedSteps);
                setMongoCompletedSteps(progressData.mongoCompletedSteps);
                setApiCompletedSteps(progressData.apiCompletedSteps);
                setAuthCompletedSteps(progressData.authCompletedSteps);
                setErrorCompletedSteps(progressData.errorCompletedSteps);
                setDeployCompletedSteps(progressData.deployCompletedSteps);
            }
        };
        asyncFunc();
        if(!currentUser && !isLoading){
            setError('Error');
        }
        else{
            setError('');
        }
    }, [currentUser]);

    return (
        <body>
            <HomeNavbar/>
            <h1 className='tech-main-title'>Backend Web Development</h1>
            <div className='web-container'>
                <div className='html-container'>
                    <h1 className='tech-title'>Setup and Basics</h1>
                    <VerticalStepper steps={SetupSteps} onStepComplete={handleSetupStepComplete} onStepBack={handleSetupStepBack} stepsCompleted={setupCompletedSteps}/>
                </div>
                <div className='js-container'>
                    <h1 className='tech-title'>Node.js and Express</h1>
                    <VerticalStepper steps={NodeSteps} onStepComplete={handleNodeStepComplete} onStepBack={handleNodeStepBack} stepsCompleted={nodeCompletedSteps}/>
                </div>
                <div className='react-container'>
                    <h1 className='tech-title'>RESTful API Development</h1>
                    <VerticalStepper steps={APISteps} onStepComplete={handleApiStepComplete} onStepBack={handleApiStepBack} stepsCompleted={apiCompletedSteps}/>
                </div>
                <div className='api-container'>
                    <h1 className='tech-title'>MongoDB and Mongoose</h1>
                    <VerticalStepper steps={MongoSteps} onStepComplete={handleMongoStepComplete} onStepBack={handleMongoStepBack} stepsCompleted={mongoCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Authentication and Security</h1>
                    <VerticalStepper steps={AuthSteps} onStepComplete={handleAuthStepComplete} onStepBack={handleAuthStepBack} stepsCompleted={authCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Error Handling and Middleware</h1>
                    <VerticalStepper steps={ErrorSteps} onStepComplete={handleErrorStepComplete} onStepBack={handleErrorStepBack} stepsCompleted={errorCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Deployment and Hosting</h1>
                    <VerticalStepper steps={DeploymentSteps} onStepComplete={handleDeployStepComplete} onStepBack={handleDeployStepBack} stepsCompleted={deployCompletedSteps}/>
                </div>
            </div>
            <ErrorModal errorMsg='Plz Login To Save Your Progress!' isError={error} />
            <LoadingModal isLoading={isLoading} msg={'Loading..'}/>
        </body>
    );
}

export default Backend;